// extracted by mini-css-extract-plugin
export default {"latest-news":"LatestNews_latest-news__Z8QDF","title":"LatestNews_title__-GPWd"};